__turbopack_context__.v({
  "applyButton": "progressive-learn-modal-module-scss-module__oKgwXa__applyButton",
  "benefitsLabel": "progressive-learn-modal-module-scss-module__oKgwXa__benefitsLabel",
  "benefitsList": "progressive-learn-modal-module-scss-module__oKgwXa__benefitsList",
  "body": "progressive-learn-modal-module-scss-module__oKgwXa__body",
  "buttonSection": "progressive-learn-modal-module-scss-module__oKgwXa__buttonSection",
  "heading": "progressive-learn-modal-module-scss-module__oKgwXa__heading",
  "hiddenBackdrop": "progressive-learn-modal-module-scss-module__oKgwXa__hiddenBackdrop",
  "highlightSection": "progressive-learn-modal-module-scss-module__oKgwXa__highlightSection",
  "offerAgreement": "progressive-learn-modal-module-scss-module__oKgwXa__offerAgreement",
  "offerDescription": "progressive-learn-modal-module-scss-module__oKgwXa__offerDescription",
  "progressiveLogo": "progressive-learn-modal-module-scss-module__oKgwXa__progressiveLogo",
  "progressiveModal": "progressive-learn-modal-module-scss-module__oKgwXa__progressiveModal",
});
